import * as apis from "@/api";
import RollItem from "../../rolls";
import ActivityItem from "../components/activity.vue";
import RebateItem from "../components/rebate.vue";
import RedEnvelopeItem from "../components/redEnvelope.vue";
import VipLevelItem from "../components/vip.vue";
import SubsidyItem from "../components/subsidy.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      tabList: [
        {
          tabname: "优惠活动",
          routerPush: "activity",
          path: "/event/activity",
        },
        { tabname: "战力奖励", routerPush: "rebate", path: "/event/rebate" },
        {
          tabname: "红包CDK",
          routerPush: "redEnvelope",
          path: "/event/redEnvelope",
        },
        { tabname: "VIP特权", routerPush: "vipLevel", path: "/event/vipLevel" },
        //{ tabname: "救援金", routerPush: "subsidy", path: "/event/subsidy" },
      ],
      currentTab: "activity",
      currentEventTab: "rolls",
      routerPushList: [
        "rolls",
        "activity",
        "rebate",
        "redEnvelope",
        "vipLevel",
        "subsidy",
      ],
      showRouteList: [],
      isEventsList: [],
      isShow: false,
    };
  },
  components: {
    "c-rollItem": RollItem,
    "c-activityItem": ActivityItem,
    "c-rebateItem": RebateItem,
    "c-redEnvelopeItem": RedEnvelopeItem,
    "c-vipLevelItem": VipLevelItem,
    "c-subsidyItem": SubsidyItem,
  },
  computed: {
    ...mapState(["acl"]),
  },
  async created() {
    this.isShow = false;
    await this.GetAcl();
    this.currentEventTab = "rolls";
    this.currentTab = "activity";
    if (this.showRouteList.indexOf("rolls") == -1) {
      this.currentEventTab = "events";
    }
    if (this.isEventsList.length == 0) {
      this.currentEventTab = "rolls";
    }
    if (this.currentEventTab == "events") {
      this.currentTab = this.isEventsList[0];
    }
    setTimeout(() => {
      this.isShow = true;
    }, 50);
  },
  methods: {
    onSwtichEventTab(data) {
      if (this.currentEventTab == data) return;
      this.currentEventTab = data;
      if (this.currentEventTab == "events") {
        this.currentTab = this.isEventsList[0];
      }
    },
    onSwtichTab(data) {
      if (this.currentTab == data) return;
      this.currentTab = data.routerPush;
      this.currentEventTab = "events";
    },
    async GetAcl() {
      console.log("acl===", this.acl);
      this.showRouteList = this.routerPushList.filter(
        (_) => this.acl.indexOf(_) == -1
      );
      this.isEventsList = this.tabList.map((_) => {
        if (this.showRouteList.indexOf(_.routerPush) > -1) {
          return _.routerPush;
        }
      });
      console.log("是否存在events===", this.isEventsList);
    },
  },
};
